const localImages = {
    logo: require('../Assets/Images/Logos/logo.png'),
    logoCircle: require('../Assets/Images/Logos/logo1.png'),
    logoVerticle: require('../Assets/Images/Logos/logo2.png'),
    loginSlide1: require('../Assets/Images/Login/loginSlide1.jpg'),
    loginSlide2: require('../Assets/Images/Login/loginSlide2.jpg'),
    loginSlide3: require('../Assets/Images/Login/loginSlide3.jpg'),
    pdfIcon: require('../Assets/Images/icons/docsUpload.png'),
    
};

export default localImages;